import React from "react";
import { BaseURL } from "../../APIs/APIUrls";

export default function FurnishingDetail({ PropertyObject }) {
  console.log("Furnishing Details:", PropertyObject);
  const furnishingDetails = Array.isArray(PropertyObject?._lstPropertyFurnishDetail)
    ? PropertyObject._lstPropertyFurnishDetail
    : [];

  return (
    <>
      <h6 className="title fw-6" style={{ marginTop: '2.1rem' }}>
        {PropertyObject.FurnishingStatus}
      </h6>
      <ul className="info-box">
        {furnishingDetails.length > 0
          ? furnishingDetails.map((item, index) => (
              <li className="item" key={item.FurnishId ?? index}>
                <a href="#" className="box-icon w-52">                  
                  <img src={BaseURL + item.IconImage} alt={`Icon for ${item.FurninshName}`} />
                </a>
                <div className="content">
                  <span>{item.FurninshName}</span>&nbsp;|&nbsp;
                  {item.Count ? <small className="text-variant-1">Qty: {item.Count}</small> : null}
                </div>
              </li>
            ))
          : null}
      </ul>
    </>

  );
}
